import ArticleCard from "../components/ArticleCard";
import { ARTICLES as posts } from "../constants/Articles";

const Articles = () => {
    return (
        <section id="articles" className="px-4 py-16 transition-colors duration-300 sm:px-6 sm:py-20 lg:px-8 lg:py-28 bg-gradient-to-b from-slate-50 to-white dark:from-slate-950 dark:to-slate-900">
            <div className="mx-auto max-w-6xl">
                <header className="mb-10 max-w-3xl sm:mb-14">
                    <div className="mb-3 flex items-center gap-3 text-sm font-bold uppercase tracking-wide text-blue-600 dark:text-blue-400">
                        <span>Notes from the work</span>
                        <span className="text-slate-400 dark:text-slate-500"></span>
                    </div>
                    <h1 className="mb-5 text-4xl font-bold text-slate-900 dark:text-white sm:text-5xl md:text-6xl">
                        Blogs
                    </h1>
                    <p className="text-lg leading-relaxed text-slate-600 dark:text-slate-300 sm:text-xl">
                        Practical lessons, experiments, and ideas from building software.
                    </p>
                </header>

                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6">
                    {posts.map((post, index) => (
                        <ArticleCard
                            article={post}
                            index={index + 1}
                            featured={post.featured}
                            key={post.postId}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Articles;